export default "__VITE_ASSET__DKXj$qKp__"